import { staticConfig } from "../../treasury.config";

export class Util {
  constructor() {
    if (this instanceof Util) {
      throw Error("A static class cannot be instantiated.");
    }
  }

  static capitalizeFirstLetter(word) {
    if (typeof word == "number") return word;
    if (!word || typeof word != "string") return "";
    return word.charAt(0).toUpperCase() + word.slice(1);
  }

  //  fieldname = field name as it is on the form
  //  value = field value or chosen answer
  //  template = object that holds all the input options

  static mapFormFieldToLabel(fieldname, value, template) {
    if (!template) return "";
    if (!fieldname) return "";
    if (!template[fieldname]) return "";
    const item = template[fieldname].find(
      (item) => item.value === value || item.key === value || item.id === value
    );
    return item?.label;
  }
  static formatFullDate(date) {
    if (!date) return "-";
    try {
      return new Date(date).toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch {
      return "-";
    }
  }
  static getSymbol(template, data) {
    const currency = template?.currencies?.find(
      (item, i) => item?.value === data?.currencyCode
    );
    return currency?.symbol ?? currency?.value;
  }
  static getCurrencyCode(template, data) {
    const currency = template?.currencies?.find(
      (item, i) => item?.value === data?.currencyCode
    );
    return currency?.value;
  }
}
